import type { WeaponStats, WeaponUpgrade } from "./WeaponStats.js";

export type WeaponUpgradeModifiers = {
  readonly [K in keyof WeaponStats]?: readonly [number, number, number];
};

/**
 * Per-slot multipliers applied to WeaponStats fields at each upgrade level [L1, L2, L3].
 *
 * reload reduces reloadMs (lower = faster fire rate).
 * velocity increases projectileSpeed; projectileLifetimeMs is re-derived
 *   from (range / speed) after all multipliers are applied, so a velocity
 *   upgrade with no range upgrade shortens lifetime while keeping the same range.
 * range increases effective range; projectileLifetimeMs is re-derived to match.
 */
export const WEAPON_UPGRADE_MODIFIERS: Record<keyof WeaponUpgrade, WeaponUpgradeModifiers> = {
  damage:   { damage:          [1.15, 1.35, 1.60] },
  reload:   { reloadMs:        [0.90, 0.80, 0.68] },
  velocity: { projectileSpeed: [1.10, 1.25, 1.45] },
  range:    { range:           [1.10, 1.25, 1.50] },
  streams:  { streams:         [2, 3, 3] },
};
